import { Extension } from "@tiptap/core";
import { DOMParser as PMDOMParser } from "@tiptap/pm/model";
import { Plugin, PluginKey } from "@tiptap/pm/state";

// Paragraphs render with margin: 0, so visual spacing between paragraphs comes
// from an empty <p> acting as a spacer (see styles.ts: p:empty::after).
export const CleanPaste = Extension.create({
  name: "cleanPaste",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("cleanPaste"),
        props: {
          transformPastedHTML(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            doc.querySelectorAll("br").forEach((br) => br.remove());

            // Markdown paragraph breaks arrive as adjacent <p> siblings.
            // Insert an empty <p> between non-empty consecutive ones.
            doc.querySelectorAll("p").forEach((p) => {
              const next = p.nextElementSibling;
              if (
                next &&
                next.tagName === "P" &&
                p.textContent?.trim() &&
                next.textContent?.trim()
              ) {
                p.parentNode?.insertBefore(doc.createElement("p"), next);
              }
            });

            return doc.body.innerHTML;
          },
          clipboardTextParser(text, $context, _plain, view) {
            const { schema } = view.state;
            const dom = document.createElement("div");

            text
              .replace(/\r\n?/g, "\n")
              .split("\n")
              .forEach((line) => {
                const p = dom.appendChild(document.createElement("p"));
                if (line) p.appendChild(document.createTextNode(line));
              });

            return PMDOMParser.fromSchema(schema).parseSlice(dom, {
              preserveWhitespace: true,
              context: $context,
            });
          },
        },
      }),
    ];
  },
});
